(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/account-services/account-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/account-services/account-selector.js');

'use strict';

const {
  CurrencyFromJupiterString: currencyFromJupiterString
} = svs.utils.format;
const accountSelector = svs.numbergames.accountSelector;
const {
  errors: {
    INVALID_ACCOUNT_SELECTED
  }
} = accountSelector.constants;
async function setActiveAccount(_ref) {
  let {
    next,
    syndicateId
  } = _ref;
  try {
    if (syndicateId) {
      await accountSelector.setActiveAccount(syndicateId);
    } else {
      await accountSelector.usePlayerAccount();
    }
  } catch (error) {
    if (error.type === INVALID_ACCOUNT_SELECTED) {
      svs.numbergames.pay_numbergames.logger.warn('AccountSelector reported that the user tried to select an inactive or non existing syndicate', error);
      return svs.numbergames.pay_numbergames.noSyndicateProlongation({
        next
      });
    }
    svs.numbergames.pay_numbergames.logger.warn('Error when selecting account from AccountSelector component', error);
    throw new Error(error);
  }
  next();
}
svs.numbergames.pay_numbergames.setActiveAccount = setActiveAccount;
async function verifyActiveAccount(_ref2) {
  let {
    next,
    cancel
  } = _ref2;
  svs.ui.loader.show();
  let account;
  try {
    account = await accountSelector.getActiveAccount();
  } catch (error) {
    if (error.type === INVALID_ACCOUNT_SELECTED) {
      svs.numbergames.pay_numbergames.logger.warn('AccountSelector reported that the user tried to play with an inactive or non existing syndicate, falling back to players account', error);
    } else {
      svs.numbergames.pay_numbergames.logger.warn('Error when getting selected account from AccountSelector component, falling back to players account', error);
    }
    try {
      account = await accountSelector.usePlayerAccount();
    } catch (err) {
      svs.numbergames.pay_numbergames.logger.warn('AccountSelector was unable to revert to using the players account, using static fallback', err);
      account = {
        isSyndicate: false
      };
    }
  }
  svs.ui.loader.hide();
  if (account.isPermissionBlocked) {
    svs.numbergames.pay_numbergames.syndicateNoPermission({
      syndicateName: account.name,
      cancel
    });
    return;
  }
  const isSyndicate = account.isSyndicate;
  const syndicate = {
    syndicateId: isSyndicate ? parseInt(account.id, 10) : account.id,
    syndicateName: account.name,
    playableAmount: account.balance
  };
  next({
    syndicate,
    isSyndicate
  });
}
async function updateAccountBalance(_ref3) {
  let {
    next,
    accountBalance,
    actualPaidPrice,
    syndicate,
    isSyndicate
  } = _ref3;
  const oldBalance = currencyFromJupiterString(accountBalance);
  const newBalance = currencyFromJupiterString(oldBalance - actualPaidPrice);
  if (isSyndicate) {
    try {
      await accountSelector.updateAccountBalance({
        accountId: syndicate.syndicateId,
        balance: newBalance
      });
    } catch (error) {
      svs.numbergames.pay_numbergames.logger.warn("AccountSelector was not able to update balance after purchase for accountId: ".concat(syndicate.id, ", new balance was: ").concat(newBalance, "."), error);
    }
  } else {
    svs.components.account_balance.set(newBalance);
  }
  next();
}
Object.assign(svs.numbergames.pay_numbergames, {
  verifyActiveAccount,
  updateAccountBalance
});

 })(window);